import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'coupons',
            name: 'coupon',
            class: 'Modules\\FerreCoupon\\Entities\\Coupon',

            formatted: {
                percentage: 'Porcentaje',
                amount: 'Cantidad'
            }
        }
    },

    methods: {
        prepareResource(resource) {
            resource.formatted_type = this.formatted[resource.type]
        }
    }
}